<template>
  <div>
    <Header/>
    <div class="account">
      <p v-if="first">
        <strong>You are now connected to the Zenodo portal for EMPIR</strong>
      </p>
      <p>
        In order to fill form fields automatically,
        you can setup your name and your affiliation.
      </p>
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="Name">
          <el-input v-model="form.name" placeholder="Family name, given names"></el-input>
        </el-form-item>
        <el-form-item label="Affiliation">
          <el-input v-model="form.organization" placeholder="Affiliation"></el-input>
        </el-form-item>
        <el-form-item class="right">
          <el-button type="primary" @click="onSubmit">Save</el-button>
          <el-button v-if="first" @click="onSkip">Skip</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Footer fixed />
  </div>
</template>

<script>

import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Account',
  props: {
    uri: String,
  },
  data() {
    const user = this.$cookies.get('user')
    let name = ''
    let organization = ''
    if (user && user.name) {
      ({ name, organization } = user)
    }

    return {
      form: {
        name,
        organization,
      },
      first: this.$route.params.first === 'first',
    }
  },
  watch: {
    $route(to) {
      this.first = to.params.first === 'first'
    },
  },
  methods: {
    onSubmit() {
      const user = this.$cookies.get('user')
      const { name, organization } = this.form
      this.$cookies.set('user', {
        ...user,
        name,
        organization,
      })
      this.$router.push('/upload/list')
    },
    onSkip() {
      this.$router.push('/upload/list')
    },
  },
  components: {
    Header,
    Footer,
  },
}
</script>

<style lang="scss">
@import "../themes.scss";

.account {
  max-width: 500px;
  margin: auto;
  padding-top: 20px;

  .right {
    text-align: right;
  }
}

</style>
